export interface Document {
    id: string;
    name: string;
    path: string;
}

export const documents: Document[] = [
    {
        id: 'gdpr',
        name: 'Protectia datelor cu caracter personal',
        path: '/docs/Protectia-si-prelucrarea-datelor-cu-caracter-personal.pdf',
    },
    {
        id: 'terms',
        name: 'Termeni si conditii',
        path: '/docs/Termeni-si-conditii.pdf',
    },
];
